// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useEffect } from "react";
import { View, Text } from "react-native";
import colors from "../../../../config/colors";
import DataTable from "./DataTable";
import styles from "../../../../styles/Farmer/DataTable1Style";

const DataTableComponent = ({
    title,
    dateFrom,
    dateTo,
    getTranslation,
    formatDate,
    shared,
    responseData,
    direction
}) => {
    const [tableData, setTableData] = useState([]);
    const [totals, setTotals] = useState([]);
    useEffect(() => {
        if (responseData != null) {
            setTableData(responseData?.data);
            setTotals(responseData?.totals);
        }
    }, [responseData]);

    return (
        <View
            style={[
                styles.content,
                {
                    backgroundColor: tableData.length > 0 ? colors.white : colors.green,
                    borderRadius: 16,
                    shadowColor: tableData.length > 0 ? colors.white : colors.green,
                    color: colors.green,
                },
            ]}
        >
            <View style={styles.labelsContainer}>
                <View style={styles.labelRow}>
                    <View style={styles.labelContainer}>
                        <Text
                            style={[styles.label, { color: colors.green, fontSize: 28 }]}
                        >
                            {totals?.length > 0 ? getTranslation("Gesamtmenge:") : ""}
                        </Text>
                    </View>
                    <View style={styles.labelContainer}>
                        <Text
                            style={[styles.label, { color: colors.green, fontSize: 28 }]}
                        >
                            {totals?.length > 0 ? totals[0]?.quantity + " t " : ""}
                        </Text>
                    </View>
                </View>
            </View>
            <DataTable
                data={tableData}
                dateFrom={dateFrom}
                dateTo={dateTo}
                getTranslation={getTranslation}
                formatDate={formatDate}
                shared={shared}
                direction={direction}
            />
        </View>
    );
};

export default DataTableComponent;
